import { combineReducers } from 'redux';

import notifications from '../../components/Notifications/reducer';
import scheduleEvents from '../../components/ScheduleEvents/reducer';
import habitat from '../../routes/habitat/reducer';
import magicLink from '../../routes/login/MagicLinkModal/reducer';
import passwordReset from '../../routes/login/ResetModal/reducer';
import map from '../../routes/map/reducer';
import myAlbum from '../../routes/myAlbum/reducers';
import schedule from '../../routes/schedule/reducer';
import allHabitats from './allHabitats';
import chat from './chat';
import config from './config';
import geoInfo from './geoInfo';
import mainStream from './mainStream';
import modals from './modals';
import plans from './plans';
import user from './user';

export default combineReducers({
  allHabitats,
  mainStream,
  user,
  chat,
  habitat,
  plans,
  map,
  schedule,
  myAlbum,
  passwordReset,
  magicLink,
  modals,
  notifications,
  scheduleEvents,
  config,
  geoInfo,
});
